import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { MasterService } from 'src/app/core/services/master.service';
import { trackById } from 'src/app/core/utils/track-by';
import { environment } from 'src/app/environments/environment';
import { CustomBreadcrumbService } from 'src/app/features/services/custom-breadcrumb.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UsersManagementService } from 'src/app/features/company-portal/modules/user-management/services/user-management.service';
import { UserAppsModel, UserModel } from 'src/app/features/company-portal/modules/user-management/models/user-management.models';
import { Apps } from '../../enums/enums';
import { Permission } from '../../models/shared.models';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  standalone: false,
})
export class LayoutComponent implements OnInit {
  trackById = trackById;
  userInfo: any;
  companyId: number = 0;
  isExpandSubMenu: boolean = false;
  submenus: any = [];
  submenusParentId: number | null = null;
  currentRoute: string = '';
  isMobileMenuOpen: boolean = false;
  @ViewChild('sidebar', { static: false }) sidebarRef!: ElementRef;
  @ViewChild('submenuSidebar', { static: false }) submenuSidebarRef!: ElementRef;
  Apps = Apps;
  imsUrl: string = environment.imsUrl;
  canShowImsMenu: boolean = environment.canShowImsOption;
  canShowAppDownloadsMenu: boolean = false;
  canShowLabelFormat: boolean = environment.canShowLabelFormat;
  allMenus = [
    {
      id: 1,
      menu: 'Product Management',
      submenus: {
        menu: 'Product Management',
        submenuArray: [
          {
            id: 7,
            menu: 'Brands',
            route: '/company-portal/brands',
            permission: 'Brand:View',
          },
          {
            id: 50,
            menu: 'Attributes',
            route: '/company-portal/product-attributes',
            permission: 'ProductAttribute:View',
          },
          {
            id: 6,
            menu: 'Category Types',
            route: '/company-portal/product-category-type/product-category-type',
            permission: 'ProductCategoryType:View',
          },
          {
            id: 19,
            menu: 'Categories',
            route: '/company-portal/product-categories',
            permission: 'ProductCategory:View',
          },
          {
            id: 20,
            menu: 'Departments',
            route: '/company-portal/product-departments',
            permission: 'ProductDepartment:View',
          },
          {
            id: 9,
            menu: 'Units',
            route: '/company-portal/units',
            permission: 'Unit:View',
          },
          {
            id: 8,
            menu: 'Tags',
            route: '/company-portal/tags',
            permission: 'Tag:View',
          },
          {
            id: 37,
            menu: 'Print Formats',
            route: '/company-portal/label-formats',
            permission: 'LabelFormat:View',
          },
          {
            id: 18,
            menu: 'Suppliers',
            route: '/company-portal/suppliers',
            permission: 'Supplier:View',
          },
        ],
      },
    },
    {
      id: 2,
      menu: 'Warehouse Management',
      submenus: {
        menu: 'Warehouse Management',
        submenuArray: [
          {
            id: 12,
            menu: 'Warehouses',
            route: '/company-portal/warehouses',
            permission: 'Warehouse:View',
          },
          {
            id: 13,
            menu: 'Zones',
            route: '/company-portal/warehouse-zones',
            permission: 'Zone:View',
          },
          {
            id: 14,
            menu: 'Location Types',
            route: '/company-portal/warehouse-location-type',
            permission: 'LocationType:View',
          },
          {
            id: 15,
            menu: 'Location Formats',
            route: '/company-portal/warehouse-location-format',
            permission: 'LocationFormat:View',
          },
          {
            id: 16,
            menu: 'Location Profiles',
            route: '/company-portal/warehouse-location-profiles',
            permission: 'LocationProfile:View',
          },
          {
            id: 17,
            menu: 'Locations',
            route: '/company-portal/warehouse-location',
            permission: 'Location:View',
          },
        ],
      },
    },
    {
      id: 3,
      menu: 'Store Management',
      submenus: {
        menu: 'Store Management',
        submenuArray: [
          {
            id: 23,
            menu: 'Stores',
            route: '/company-portal/stores',
            permission: 'Warehouse:View',
          },
          {
            id: 25,
            menu: 'Store Groups',
            route: '/company-portal/store-groups',
            permission: 'Warehouse:View',
          },
          {
            id: 26,
            menu: 'Goal Groups',
            route: '/company-portal/goal-groups',
            permission: 'Zone:View',
          },
        ],
      },
    },
    {
      id: 4,
      menu: 'Data Management',
      submenus: {
        menu: 'Data Management',
        submenuArray: [
          {
            id: 28,
            menu: 'Brands',
            route: '/admin-portal/brands',
            permission: 'Brand:View',
          },
          {
            id: 29,
            menu: 'Product Categories',
            route: '/admin-portal/product-categories',
            permission: 'ProductCategory:View',
          },
          {
            id: 30,
            menu: 'Product Departments',
            route: '/admin-portal/product-departments',
            permission: 'ProductDepartment:View',
          },
          {
            id: 31,
            menu: 'Store Types',
            route: '/admin-portal/store-types',
            permission: 'StoreType:View',
          },
          {
            id: 32,
            menu: 'Store Groups',
            route: '/admin-portal/store-groups',
            permission: 'StoreGroup:View',
          },
          {
            id: 33,
            menu: 'Product Attributes',
            route: '/admin-portal/product-attributes',
            permission: 'ProductAttribute:View',
          },
        ],
      },
    },
    {
      id: 5,
      menu: 'Billing System',
      submenus: {
        menu: 'Billing System',
        submenuArray: [
          {
            id: 34,
            menu: 'Billable Services',
            route: '/admin-portal/billing-system/billable-services',
            permission: 'BillableService:View',
          },
          {
            id: 35,
            menu: 'Subscription Plans',
            route: '/admin-portal/billing-system/subscription-plans',
            permission: 'SubscriptionPlan:View',
          },
          {
            id: 36,
            menu: 'Company Discounts',
            route: '/admin-portal/billing-system/company-discounts',
            permission: 'CompanyDiscount:View',
          },
          {
            id: 38,
            menu: 'Invoices',
            route: '/admin-portal/billing-system/invoices',
            permission: 'Invoice:View',
          },
        ],
      },
    },
  ];
  settingRoutes: any = [
    '/company-portal/settings/billing',
    '/company-portal/settings/api-users',
    '/company-portal/settings/company-settings',
    '/admin-portal/settings/datadog-settings',
  ];
  allMenusCopy = JSON.parse(JSON.stringify(this.allMenus));
  companyAppId = Apps.CompanyPortal;
  adminAppId = Apps.AdminPortal;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private customBreadcrumbService: CustomBreadcrumbService,
    private permissionService: NgxPermissionsService,
    private sharedService: SharedService,
    private userManagementService: UsersManagementService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit(): void {
    this.userInfo = this.masterService.getUserDetailFromStorage();
    this.companyId = parseInt(this.userInfo.companyid);
    this.sharedService.callMethod$.subscribe(() => {
      this.getUserScope();
    });
    this.sharedService.sidebarToggle$.subscribe(() => {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    });
    this.getUserScope();
    this.currentRoute = this.router.url;
  }

  /** Permission handling (same as before) */
  getUserScope(): Promise<void> {
    return this.companyId == -1 ? this.getAdminPermissions() : this.getCompanyPermissions();
  }

  getAdminPermissions(): Promise<void> {
    return this.masterService.getRolesandPerm(this.adminAppId).then((res) => {
      const perm = (res as Permission[]).map((p) => p.name) ?? [];
      this.permissionService.loadPermissions(perm);
    });
  }

  getCompanyPermissions(): Promise<void> {
    return this.masterService.getRolesandPerm(this.companyAppId).then((res) => {
      const perm = (res as Permission[]).map((p) => p.name) ?? [];
      this.allMenus = JSON.parse(JSON.stringify(this.allMenusCopy));
      this.allMenus.forEach((menu: any) => {
        menu.submenus.submenuArray = menu.submenus.submenuArray.filter((sm: any) =>
          perm.includes(sm.permission),
        );
      });
      this.permissionService.loadPermissions(perm);
      this.checkAppDownloadsVisibility();
    });
  }

  checkAppDownloadsVisibility(): void {
    const userId = this.userInfo.userid;
    this.userManagementService.getUserLiteById(userId, false).subscribe({
      next: (user: UserModel) => {
        this.canShowAppDownloadsMenu = user?.apps?.some(
          (app: UserAppsModel) => app.id === Apps.TPM || app.id === Apps.POS,
        ) ?? false;
      },
      error: () => {
        this.canShowAppDownloadsMenu = false;
      },
    });
  }

  /** Submenu toggle */
  toggleSubMenus(opt: number) {
    const menu = this.allMenus.find((item: any) => item.id === opt);
    if (!menu || ![1, 2, 3, 4, 5].includes(opt)) {
      this.isExpandSubMenu = false;
      this.isMobileMenuOpen = false;
      return;
    }

    if (this.submenusParentId === opt) {
      this.isExpandSubMenu = !this.isExpandSubMenu;
    } else {
      this.submenus = menu.submenus;
      this.submenusParentId = menu.id;
      this.isExpandSubMenu = true;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const sidebarEl = this.sidebarRef?.nativeElement;
    const target = event.target as Node;
    if (this.isExpandSubMenu) {
      const submenuEl = this.submenuSidebarRef?.nativeElement;
      if (sidebarEl && submenuEl && !sidebarEl.contains(target) && !submenuEl.contains(target)) {
        this.isExpandSubMenu = false;
      }
    }
    if (this.isMobileMenuOpen) {
      if (
        sidebarEl &&
        !sidebarEl.contains(target) &&
        !(target as HTMLElement).closest('.back-btn')
      ) {
        this.isMobileMenuOpen = false;
      }
    }
  }

  isMenuActive(menu: any): boolean {
    return menu.submenus.submenuArray.some((sm: any) => this.router.isActive(sm.route, false));
  }

  getMenuLink(menu: any, defaultRoute: string): string | null {
    // If already in one of the submenu routes, don't redirect
    if (this.isMenuActive(menu)) {
      return null;
    }
    // Otherwise, redirect to the default route
    return defaultRoute;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  redirectToModule(appId: number) {
    if (appId === Apps.Inventory) {
      window.location.href = this.imsUrl;
    }
  }
}
